export { default } from './LocaleTitle';
